<template>
    <!-- Desktop: show search -->
    <div class="hidden lg:block max-w-6xl">
        <SearchForm />
    </div>

    <!-- Mobile: open modal -->
    <button class="btn btn-lg bg-white border border-gray-200 md:inline-flex! flex rounded-full! w-full md:w-auto lg:hidden! gap-2 hover:text-primary shadow-custom" @click="openSearch">
        <i class="icon-search text-base"></i>
        {{ $t('Start your search') }}
    </button>

    <!-- Mobile modal -->
    <Modal ref="searchModal" @close="closeSearch">
        <template #header>
            {{ $t('Search') }}
        </template>
        <div class="search-modal-content">
            <SearchForm />
        </div>
    </Modal>
</template>

<script setup>
import { useProductsStore } from '@/stores/products'
import { storeToRefs } from 'pinia'

const props = defineProps({
    locationName: { type: String, default: '' },
    // SEO listing path (from the entry's "Search url" field, e.g. `hrvaska`) to
    // open when Search is clicked without touching the "Where?" field.
    searchUrl: { type: String, default: '' },
})

// Preset the "Where?" field from the CMS entry, unless the store already
// holds a location (e.g. carried over from the URL query).
const { params, context } = storeToRefs(useProductsStore())
const hasLocation = params.value.propertyId || params.value.locationId || params.value.regionId || params.value.regionGroupId

if (!hasLocation && props.searchUrl) {
    params.value.q = props.locationName

    // Seed the SEO listing path so submitting the form unchanged (or on
    // mobile, without ever opening the "Where?" picker) still lands on
    // /nastanitve/{searchUrl} instead of a plain /ponudbe query search.
    if (!context.value) {
        context.value = { id: null, label: props.locationName, url: props.searchUrl }
    }
}

const searchModal = ref(null)

const openSearch = () => {
    searchModal.value?.openModal()
}

const closeSearch = () => {
    searchModal.value?.closeModal()
}
</script>
